import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OutlineButtonComponent } from '../../../../shared/components/outline-button/outline-button';
import { PrimaryButtonComponent } from '../../../../shared/components/primary-button/primary-button';

@Component({
  selector: 'app-submit-examination-details-popup',
  imports: [OutlineButtonComponent, PrimaryButtonComponent],
  templateUrl: './submit-examination-details-popup.html',
  styleUrl: './submit-examination-details-popup.css',
})
export class SubmitExaminationDetailsPopupComponent {
  @Input() isOpen = false;
  @Input() totalQuestions = 0;
  @Input() answeredCount = 0;
  @Input() notAnsweredCount = 0;
  @Input() markedForReviewCount = 0;
  @Input() notVisitedCount = 0;

  @Output() close = new EventEmitter<void>();
  @Output() submit = new EventEmitter<void>();

  protected get summaryRows(): Array<{
    label: string;
    value: number;
    valueClass: string;
  }> {
    return [
      { label: 'Total Questions', value: this.totalQuestions, valueClass: 'text-mock-gray-900' },
      { label: 'Answered', value: this.answeredCount, valueClass: 'text-mock-green-200' },
      { label: 'Not Answered', value: this.notAnsweredCount, valueClass: 'text-mock-red-900' },
      { label: 'Marked for Review', value: this.markedForReviewCount, valueClass: 'text-mock-purple-500' },
      { label: 'Not Visited', value: this.notVisitedCount, valueClass: 'text-mock-gray-400' },
    ];
  }

  protected onClose(): void {
    this.close.emit();
  }

  protected onSubmit(): void {
    this.submit.emit();
  }
}
